module.exports = __webpack_public_path__ + "static/media/noun-discussion.307fd55e.svg";